import { useUnreadsQuery } from './queries';

const EMPTY_TASK = { comments: 0, mentions: 0, hasUnread: false };
const EMPTY_PROJECT = { tasks: 0, mentions: 0, hasUnread: false };

/**
 * Unread state for one task.
 *
 * Reads from the single cached /api/unreads entry, so rendering this in a
 * thousand rows costs one request, not a thousand.
 */
export const useUnreadTask = (taskId) => {
  const { data } = useUnreadsQuery();
  const entry = taskId ? data?.tasks?.[taskId] : null;
  if (!entry) return EMPTY_TASK;
  return {
    comments: entry.comments || 0,
    mentions: entry.mentions || 0,
    hasUnread: (entry.comments || 0) > 0,
  };
};

/** Rolled-up unread state for one project. */
export const useUnreadProject = (projectId) => {
  const { data } = useUnreadsQuery();
  const entry = projectId ? data?.projects?.[projectId] : null;
  if (!entry) return EMPTY_PROJECT;
  return {
    tasks: entry.tasks || 0,
    mentions: entry.mentions || 0,
    hasUnread: (entry.tasks || 0) > 0,
  };
};
